import React from 'react';

const JoinUs: React.FC = () => {
    return (
        <div>
            <h1>Join Us</h1>
            {/* Your code here */}
        </div>
    );
};

export default JoinUs;